import { Outlet } from "react-router-dom";
import Sidebar from "./SiderBar";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import clsx from "clsx";
import menu from '../data/menu_user.json';
import { Button } from "components/base/Button";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/outline";
import { useUser } from "context/user-context";

interface UserLayoutProps {
	headerFixed?: boolean;
	menuMobilePosition?: string;
	containerClasses?: string;
}

export default function UserLayout({
	headerFixed,
	menuMobilePosition,
	containerClasses
}: UserLayoutProps) {
	const { logout } = useUser();
	return (
		<div className="h-screen flex flex-col bg-gray-50 flex-1">
			<NavBar fixed={headerFixed} shadow menuMobilePosition={menuMobilePosition} />
			<div className={clsx("flex flex-1 max-h-[calc(100vh-var(--navbar-height)-2rem)]",
				containerClasses)}>
				<Sidebar
					menu={menu}
					bottomButton={
						<>
							<div className="hidden md:block">
								<Button variant="alert-outline" icon={<ArrowRightStartOnRectangleIcon />} onClick={logout}>Se déconnecter</Button>
							</div>
							<div className="md:hidden">
								<Button variant="alert-outline" icon={<ArrowRightStartOnRectangleIcon />} onClick={logout} />
							</div>
						</>
					}
				/>
				<main className="flex-1 p-6 -my-4 overflow-y-auto">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
